import { useBreakpoint } from '../../hooks/useBreakpoint'
import { WrapSection } from '../../components/WrapSection/WrapSection'
import { Section } from '../../components/Section/Section'
import { Banner } from '../../components/Banner/Banner'
import { Video } from '../../components/Video/Video'
import { AnimQueueText } from '../../components/AnimQueueText/AnimQueueText'
import { Footnote } from '../../components/Footnote/Footnote'
import { Title } from '../../components/Title/Title'
import { Accordion } from '../../components/Accordion/Accordion'
import { RealizeCards } from '../../components/RealizeCards/RealizeCards'
import { Marquee } from '../../components/Marquee/Marquee'
import { GridLogos } from '../../components/GridLogos/GridLogos'
import { 
    BANNER, VIDEO, ANNUAL_CAMP, HIGHLIGHTS,
    CONFERENCE_REPORTS, VILLAGE_CAMP, ACTIVITIES,
    BALANCE_AND_SPORTS, MARQUEE, FAMILY, BETWEEN_CAMPS,
    CREATORS, DELEGATES
} from './consts'
import { SliderModal } from '../../components/SliderModal/SliderModal'

export default function PostRealize() {
    const breakpoint = useBreakpoint();

    return breakpoint === '' ? null : (
        <>
            <WrapSection>
                {/* Титульный */}
                <Section>
                    <Banner
                        title={ BANNER.title[breakpoint === 'desktop' ? 0 : 1] }
                        text={ BANNER.text }
                        isMobileSmallText={ true }
                        isMobileInnerAlign="top"
                    />
                </Section>
                <Section>
                    <Video { ...VIDEO } />
                </Section>
                <Section>
                    <AnimQueueText
                        text={ ANNUAL_CAMP.text }
                        images={ ANNUAL_CAMP.images }
                        mobileImage={ ANNUAL_CAMP.mobileImage }
                    />
                    <Footnote text={ ANNUAL_CAMP.footnote } textNotAlign />
                </Section>
                <Section>
                    <Title texts={ HIGHLIGHTS.title[breakpoint === 'desktop' ? 0 : 1] } />
                    <Footnote text={ HIGHLIGHTS.footnote } textNotAlign />
                    <Accordion items={ HIGHLIGHTS.accordion} />
                </Section>
                <Section>
                    <Title texts={ CONFERENCE_REPORTS.title[breakpoint === 'desktop' ? 0 : 1] } />
                    <RealizeCards { ...CONFERENCE_REPORTS.cards } />
                </Section>
                <Section>
                    <Title texts={ VILLAGE_CAMP.title[breakpoint === 'desktop' ? 0 : 1] } isMarginBottom={ true } />
                    <AnimQueueText
                        text={ VILLAGE_CAMP.text }
                        images={ VILLAGE_CAMP.images }
                        mobileImage={ VILLAGE_CAMP.mobileImage }
                    />
                    <Footnote text={ VILLAGE_CAMP.footnote } textNotAlign />
                </Section>
                <Section>
                    <Title texts={ ACTIVITIES.title[breakpoint === 'desktop' ? 0 : 1] } />
                    <RealizeCards { ...ACTIVITIES.cards } />
                </Section>
            </WrapSection>
            <WrapSection color="black">
                <Section>
                    <Title texts={ BALANCE_AND_SPORTS.title[breakpoint === 'desktop' ? 0 : 1] } />
                    <RealizeCards { ...BALANCE_AND_SPORTS.cards } />
                    <Marquee { ...MARQUEE } theme="black"/>
                </Section>
                <Section>
                    <Title texts={ FAMILY.title[breakpoint === 'desktop' ? 0 : 1] } isMarginBottom={ true } />
                    <AnimQueueText
                        text={ FAMILY.text }
                        images={ FAMILY.images }
                        mobileImage={ FAMILY.mobileImage }
                    />
                    <Footnote text={ FAMILY.footnote } textNotAlign />
                </Section>
            </WrapSection>
            <WrapSection>
                <Section>
                    <Title texts={ BETWEEN_CAMPS.title[breakpoint === 'desktop' ? 0 : 1] } isMarginBottom={ true } />
                    <AnimQueueText
                        text={ BETWEEN_CAMPS.text }
                        images={ BETWEEN_CAMPS.images }
                        mobileImage={ BETWEEN_CAMPS.mobileImage }
                    />
                    <Footnote text={ BETWEEN_CAMPS.footnote } more={ BETWEEN_CAMPS.more } textNotAlign />
                    <Marquee { ...MARQUEE } />
                </Section>
                <Section>
                    <Title texts={ CREATORS.title[breakpoint === 'desktop' ? 0 : 1] } />
                    <GridLogos { ...CREATORS.logos } />
                </Section>
                <Section>
                    <Title texts={ DELEGATES.title[breakpoint === 'desktop' ? 0 : 1] } />
                    <GridLogos { ...DELEGATES.logos } />
                </Section>
            </WrapSection>
            <SliderModal />
        </>
    )
}
